import TuneIcon from "@mui/icons-material/Tune";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SystemBanner } from "../../../../components/UIToolkit/molecules/SystemBanner";
import SystemButton from "../../../../components/UIToolkit/SystemButton/SystemButton";

type Props = {
	/** Reopens `PredictionSetupDialog` at step 1. */
	onResume: () => void;
};

/**
 * What a closed setup flow leaves behind. The department still has no CMI source, so every HPPD
 * measure below is scored against the national-average seed — the banner says so, and carries the
 * only affordance that reopens the flow within the session.
 *
 * Rendered by `ScoringAndRecommendations` in exactly the state the dialog would otherwise occupy:
 * the gate is still open, the user closed it. Finishing setup clears both.
 */
export const PredictionSetupBanner: FC<Props> = ({ onResume }) => {
	const { t } = useTranslation();

	return (
		<SystemBanner
			tone="warning"
			icon={<TuneIcon />}
			title={t("pbj_model.setup.banner.title")}
			description={t("pbj_model.setup.banner.description")}
			action={
				<SystemButton buttonVariant="secondary" size="small" noFullWidthMobile onClick={onResume} data-testid="pbj-model-setup-resume">
					{t("pbj_model.setup.banner.resume")}
				</SystemButton>
			}
			dataTestId="pbj-model-setup-banner"
		/>
	);
};
